import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';

import CommonTokenExpired from './components/CommonTokenExpired';

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
import InputMasterDataEducationArea from './inputs/InputMasterDataEducationArea';
import SearchMasterDataEducationArea from './searchs/SearchMasterDataEducationArea';
import DataTableMasterDataEducationArea from './dataTables/DataTableMasterDataEducationArea';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/MasterDataEducationAreaState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `education_area`;
const URL = `api/master/${TABLE}`;
class MasterDataEducationArea extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadDataTable();
    }

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true}
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable
        );
    }

    componentDidMount = async () => {
        await this.initialize(); 
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchMasterDataEducationArea 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Operation={Operation}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableMasterDataEducationArea 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Operation={Operation}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }
                        onReorder={async(obj) => { await this.reorder(obj); }}

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputMasterDataEducationArea 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Operation={Operation}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}

                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
            </>
        )
    }
}

export default MasterDataEducationArea;